/* PDP-led Net Return setup builder, version 2.4.
   The native PDP form owns the "net only" path. Package and custom modes use
   Shopify's multi-item cart endpoint and the theme's existing cart-drawer events. */
(function () {
  var CATEGORY_DEFINITIONS = {
    recommended: {
      title: 'Recommended',
      sources: []
    },
    technology: {
      title: 'Technology',
      sources: ['/collections/launch-monitors/products.json?limit=50']
    },
    containment: {
      title: 'Containment',
      sources: ['/collections/accessories-safety/products.json?limit=50']
    },
    hitting: {
      title: 'Hitting area',
      sources: ['/collections/golf-hitting-mats/products.json?limit=50']
    },
    simulation: {
      title: 'Simulation',
      sources: ['/collections/accessories-simulation/products.json?limit=50']
    },
    care: {
      title: 'Care & setup',
      sources: [
        '/collections/accessories-essentials/products.json?limit=50',
        '/collections/accessories-other/products.json?limit=50'
      ]
    },
    training: {
      title: 'Training',
      sources: ['/collections/accessories-training-aids/products.json?limit=50']
    }
  };

  var CATALOG_RULES = {
    'universal-side-barriers': { category: 'containment', variants: { home: 55741046751601, pro: 55741046751601, pro8: 55741046751601, pro9: 55741046751601, pro10: 55741046751601, proxl: 55741046751601, mini: 55741046751601 } },
    'net-guardian': { category: 'containment', variants: { home: 55741057466737, pro: 55741057466737, pro8: 55741057466737, pro9: 55741057466737, pro10: 55741031186801, proxl: 55741031186801 } },
    'no-fly-zone-v2': { category: 'containment', variants: { home: 55741031055729, pro: 55741031121265, pro8: 55741031121265, pro9: 55741031154033, pro10: 41459967230045 } },
    'frame-pads': { category: 'containment', variants: { home: 42187629330525, pro: 42187644207197, pro8: 42187647483997, pro9: 42187647516765, pro10: 42187647549533, mini: 42187644272733 } },
    'pro-turf-golf-practice-mat': { category: 'hitting' },
    'country-club-t-turf-reel-feel-2x3-thick-tee': { category: 'hitting' },
    'platinum-turf': { category: 'hitting' },
    'divot-board-turf-mat-4x5-bundle': { category: 'hitting' },
    'simulator-kit-golf-simulator-screen-valence': { category: 'simulation', variants: { home: 42187536564317, pro: 42187539546205, pro8: 42187539578973, pro9: 42187539611741, pro10: 42187539644509, proxl: 42187539677277 }, conflicts: ['simulator-screen', 'simulator-valence'] },
    'simulator-screen': { category: 'simulation', variants: { home: 64531123896689, pro: 42187483775069, pro8: 64531123962225, pro9: 64531123994993, pro10: 64531124027761, proxl: 64531124027761 }, conflicts: ['simulator-kit-golf-simulator-screen-valence'] },
    'simulator-valence': { category: 'simulation', variants: { home: 42187564056669, pro: 64531123929457, pro8: 42187564154973, pro9: 42187564187741, pro10: 42187564220509, proxl: 42187564253277 }, conflicts: ['simulator-kit-golf-simulator-screen-valence'] },
    'split-screen-add-on-for-nets': { category: 'simulation', variants: { home: 42187611275357, pro: 42187611308125, pro8: 42187611340893, pro9: 42187611373661, pro10: 42187611406429, proxl: 42187611439197 } },
    'floor-mounted-projector-case': { category: 'simulation', netKeys: ['home', 'pro', 'pro8', 'pro9', 'pro10', 'proxl'] },
    'outdoor-cover': { category: 'care', variants: { home: 55741030007153, pro: 55741030039921, pro9: 42187439997021, pro8: 55741030072689, mini: 55741030170993 } },
    'sandbags': { category: 'care' },
    'rubber-tees1': { category: 'care' },
    '2-x3-target-new': { category: 'care' },
    'precision-target': { category: 'care' },
    'regular-duffle-bag': { category: 'care' },
    'the-net-return-caterpillar-bag': { category: 'care' },
    'the-net-return-neat-net': { category: 'care' },
    'gpod-travel-sportsbox-3d-player-annual-swing-analysis': { category: 'training' },
    'divot-board': { category: 'training' },
    'thestack-stack-radar-bundle': { category: 'training' },
    'g-bundle-one-gpod-w-gpod-base': { category: 'training' },
    'gpod': { category: 'training' },
    'thestack-speed-trainer-award-winning-app': { category: 'training' },
    'stack-radar-launch-monitor-club-speed-training': { category: 'training' },
    'g-bundle-two-gpod-x-w-gpod-base': { category: 'training' },
    'gpod-x': { category: 'training' },
    'timeless': { category: 'training' },
    'gpod-pauly-p': { category: 'training' }
  };

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    var numeric = Number(number);
    if (Number.isNaN(numeric) || number == null) return '0';

    var fixed = (numeric / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  function plainText(html) {
    if (html.indexOf('<') === -1 && html.indexOf('&') === -1) return html;
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || html.replace(/<[^>]*>/g, '');
  }

  function money(cents) {
    var settings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;

    switch (placeholder) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'"); break;
      default: value = formatWithDelimiters(cents, 2);
    }

    return plainText(formatString.replace(placeholderRegex, value)).replace(/([$£€¥])\s+(?=\d)/g, '$1');
  }

  function waitForCartDrawerReady(timeout) {
    if (!window.customElements || !window.customElements.whenDefined) return Promise.resolve(false);
    if (window.customElements.get('cart-drawer')) return Promise.resolve(true);
    return Promise.race([
      window.customElements.whenDefined('cart-drawer').then(function () { return true; }),
      new Promise(function (resolve) {
        window.setTimeout(function () { resolve(!!window.customElements.get('cart-drawer')); }, timeout || 1200);
      })
    ]);
  }

  function openMiniCartFallback(sectionHtml) {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    if (sectionHtml) {
      var container = document.createElement('div');
      container.innerHTML = sectionHtml;
      var nextDrawer = container.querySelector('#mini-cart');
      if (nextDrawer) drawer.innerHTML = nextDrawer.innerHTML;
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock-all');
  }

  function closeMiniCartFallback() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock-all');
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function setupInstance(productHandle, netKey) {
    var storageKey = 'nr_setup_instance:' + (productHandle || netKey || 'net');
    var instance = '';
    try { instance = window.sessionStorage.getItem(storageKey) || ''; } catch (error) { instance = ''; }
    if (instance) return instance;

    if (window.crypto && typeof window.crypto.randomUUID === 'function') instance = window.crypto.randomUUID();
    else instance = 'nr-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { window.sessionStorage.setItem(storageKey, instance); } catch (error) { /* Session storage is optional. */ }
    return instance;
  }

  function init(root) {
    if (root.dataset.fd26Init) return;
    root.dataset.fd26Init = '1';

    var netVariantId = parseInt(root.dataset.netVariant, 10) || 0;
    var netPrice = parseInt(root.dataset.netPrice, 10) || 0;
    var netTitle = root.dataset.netTitle || 'Net';
    var netKey = root.dataset.netKey || '';
    var barrierTriggerVid = root.dataset.fd26BarrierTriggerVid || '';
    var productHandle = root.dataset.productHandle || '';
    var packageVariantId = parseInt(root.dataset.packageVariant, 10) || 0;
    var packagePrice = parseInt(root.dataset.packagePrice, 10) || 0;
    var productFormId = root.dataset.productFormId || '';
    var themeRoutes = window.themeVariables && window.themeVariables.routes ? window.themeVariables.routes : {};
    var themeSettings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var cartAddUrl = root.dataset.cartAddUrl || themeRoutes.cartAddUrl || '/cart/add';
    var cartUrl = root.dataset.cartUrl || themeRoutes.cartUrl || '/cart';
    var cartType = root.dataset.cartType || themeSettings.cartType || 'drawer';
    var genericError = root.dataset.genericError || 'Sorry, something went wrong adding to cart. Please try again.';
    var networkError = root.dataset.networkError || 'Network error. Please try again.';
    var instanceId = setupInstance(productHandle, netKey);
    var currentMode = 'net';
    var lastDialogTrigger = null;
    var trackedView = false;
    var trackedQuickView = false;

    var modeInputs = Array.prototype.slice.call(root.querySelectorAll('.fd26-cs__mode-input'));
    var modeActions = root.querySelector('[data-fd26-mode-actions]');
    var packageAction = root.querySelector('[data-fd26-package-action]');
    var openAction = root.querySelector('[data-fd26-open]');
    var quickPanel = root.querySelector('[data-fd26-quick-add]');
    var quickToggles = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-quick-toggle]'));
    var quickCartAction = root.querySelector('[data-fd26-quick-cart]');
    var quickCountNode = root.querySelector('[data-fd26-quick-count]');
    var quickStatus = root.querySelector('[data-fd26-quick-status]');
    var status = root.querySelector('[data-fd26-status]');
    var dialog = root.querySelector('[data-fd26-dialog]');
    var closeAction = root.querySelector('[data-fd26-close]');
    var backAction = root.querySelector('[data-fd26-back]');
    var reviewAction = root.querySelector('[data-fd26-review]');
    var cartAction = root.querySelector('[data-fd26-cart]');
    var dialogStatus = root.querySelector('[data-fd26-dialog-status]');
    var chooseStep = root.querySelector('[data-fd26-step="choose"]');
    var reviewStep = root.querySelector('[data-fd26-step="review"]');
    var chooseProgress = root.querySelector('[data-fd26-progress="choose"]');
    var reviewProgress = root.querySelector('[data-fd26-progress="review"]');
    var products = root.querySelector('[data-fd26-products]');
    var categories = root.querySelector('[data-fd26-categories]');
    var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-category]'));
    var categoryTitle = root.querySelector('[data-fd26-category-title]');
    var catalogStatus = root.querySelector('[data-fd26-catalog-status]');
    var seeAllAction = root.querySelector('[data-fd26-see-all]');
    var summaryLists = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-summary-list]'));
    var reviewList = root.querySelector('[data-fd26-review-list]');
    var countNodes = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-count]'));
    var totalNodes = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-total]'));
    var reviewTotalNode = root.querySelector('[data-fd26-review-total]');
    var netPriceNode = root.querySelector('[data-fd26-net-price]');
    var formRoot = root.closest('.product-form') || document;
    var mainBuyButton = formRoot.querySelector('#AddToCart, [data-product-add-to-cart-button]');
    var nativeBuyContainer = mainBuyButton ? (mainBuyButton.closest('.mt-30') || mainBuyButton.closest('.product-form__buy-buttons')) : null;
    var nativeForm = productFormId ? document.getElementById(productFormId) : null;
    if (!nativeForm && formRoot !== document) nativeForm = formRoot.querySelector('form[action*="/cart/add"]');
    var stickyForms = Array.prototype.slice.call(document.querySelectorAll('product-sticky-form'));
    var activeCategory = 'recommended';
    var loadedCategories = { recommended: true };
    if (root.querySelector('[data-fd26-card][data-category="technology"]')) {
      loadedCategories.technology = true;
    }

    function track(eventName, detail) {
      var items = selectedItems();
      var payload = {
        event: eventName,
        nr_setup_instance: instanceId,
        nr_setup_mode: currentMode,
        nr_setup_path: detail && detail.path ? detail.path : '',
        nr_product_handle: productHandle,
        nr_net_key: netKey,
        nr_net_variant_id: netVariantId,
        nr_selected_add_on_count: items.length,
        nr_selected_variant_ids: items.map(function (item) { return item.id; })
      };
      Object.keys(detail || {}).forEach(function (key) {
        if (key !== 'path') payload['nr_' + key] = detail[key];
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('nr:setup', { detail: payload }));
    }

    function ensureNativeProperty(name, value) {
      if (!nativeForm) return;
      var input = nativeForm.querySelector('input[name="properties[' + name + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        nativeForm.appendChild(input);
      }
      input.value = value;
    }

    ensureNativeProperty('_nr_setup_instance', instanceId);
    ensureNativeProperty('_nr_setup_path', 'net_only');
    ensureNativeProperty('_nr_setup_role', 'base');

    function allToggles() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-fd26-toggle]'));
    }

    function selectedToggles() {
      return allToggles().filter(function (toggle) { return toggle.getAttribute('aria-pressed') === 'true'; });
    }

    function selectedItems() {
      var seen = {};
      return selectedToggles().reduce(function (items, toggle) {
        var id = parseInt(toggle.dataset.vid, 10);
        if (!id || seen[id]) return items;
        seen[id] = true;
        items.push({
          id: id,
          price: parseInt(toggle.dataset.price, 10) || 0,
          title: toggle.dataset.title || 'Add-on',
          variantTitle: toggle.dataset.variantTitle || '',
          image: toggle.dataset.image || '',
          toggle: toggle
        });
        return items;
      }, []);
    }

    function baseItem() {
      var productMedia = document.querySelector('.product__media img, .product-gallery__image img, [data-media-id] img');
      return {
        id: netVariantId,
        price: netPrice,
        title: netTitle,
        variantTitle: '',
        image: productMedia ? (productMedia.currentSrc || productMedia.src) : '',
        base: true
      };
    }

    function appendSummaryItem(container, item) {
      var row = element('div', 'fd26-cs__summary-item');
      if (item.image) {
        var image = element('img');
        image.src = item.image;
        image.alt = '';
        row.appendChild(image);
      } else {
        row.appendChild(element('span'));
      }

      var copy = element('span', 'fd26-cs__summary-item-copy');
      copy.appendChild(element('span', 'fd26-cs__summary-item-title', item.title));
      if (item.variantTitle) copy.appendChild(element('span', 'fd26-cs__summary-item-variant', item.variantTitle));
      row.appendChild(copy);
      row.appendChild(element('strong', 'fd26-cs__summary-item-price', money(item.price)));
      container.appendChild(row);
    }

    function appendReviewItem(item) {
      var row = element('article', 'fd26-cs__review-item');
      if (item.image) {
        var image = element('img');
        image.src = item.image;
        image.alt = '';
        row.appendChild(image);
      } else {
        row.appendChild(element('span'));
      }

      var copy = element('div', 'fd26-cs__review-copy');
      copy.appendChild(element('h3', 'fd26-cs__review-title', item.title));
      if (item.variantTitle) copy.appendChild(element('span', 'fd26-cs__review-variant', item.variantTitle));
      row.appendChild(copy);

      var price = element('div', 'fd26-cs__review-price');
      price.appendChild(element('strong', '', money(item.price)));
      if (!item.base) {
        var remove = element('button', 'fd26-cs__remove', 'Remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', 'Remove ' + item.title);
        remove.addEventListener('click', function () {
          setToggle(item.toggle, false);
          renderSelection();
          track('nr_setup_add_on_toggle', {
            path: 'full_builder',
            add_on_handle: item.toggle.dataset.handle || '',
            add_on_variant_id: item.id,
            selected: false
          });
          if (!selectedItems().length) showStep('choose');
        });
        price.appendChild(remove);
      }
      row.appendChild(price);
      reviewList.appendChild(row);
    }

    function renderSelection() {
      syncBarrierOptions();
      var items = [baseItem()].concat(selectedItems());
      var total = items.reduce(function (sum, item) { return sum + item.price; }, 0);

      summaryLists.forEach(function (list) {
        list.textContent = '';
        items.forEach(function (item) { appendSummaryItem(list, item); });
      });

      if (reviewList) {
        reviewList.textContent = '';
        items.forEach(appendReviewItem);
      }

      countNodes.forEach(function (node) {
        node.textContent = items.length + (items.length === 1 ? ' item' : ' items');
      });
      totalNodes.forEach(function (node) { node.textContent = money(total); });
      if (reviewTotalNode) reviewTotalNode.textContent = money(total);

      var hasAddOn = items.length > 1;
      if (reviewAction) {
        reviewAction.disabled = !hasAddOn;
        reviewAction.textContent = hasAddOn ? 'Review setup · ' + money(total) : 'Choose an add-on';
      }
      if (cartAction) cartAction.textContent = 'Add setup to cart · ' + money(total);
      if (quickCartAction) {
        quickCartAction.disabled = !hasAddOn;
        quickCartAction.textContent = hasAddOn ? 'Add setup to cart · ' + money(total) : 'Choose an add-on';
      }
      if (quickCountNode) {
        var addOnCount = items.length - 1;
        quickCountNode.textContent = addOnCount ? addOnCount + (addOnCount === 1 ? ' add-on selected' : ' add-ons selected') : 'No add-ons selected';
      }
      if (barrierTriggerVid && barrierTriggerVid !== '0') applyCategory(activeCategory);
    }

    function syncQuickToggle(toggle, on) {
      var handle = toggle.dataset.handle || '';
      var vid = toggle.dataset.vid || '';
      quickToggles.forEach(function (quickToggle) {
        if (quickToggle.dataset.handle !== handle || quickToggle.dataset.vid !== vid) return;
        quickToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        quickToggle.classList.toggle('is-on', on);
        var quickLabel = quickToggle.querySelector('[data-fd26-quick-label]');
        if (quickLabel) quickLabel.textContent = on ? 'Added' : 'Add';
      });
    }

    function setToggle(toggle, on) {
      if (on) {
        var handle = toggle.dataset.handle || '';
        var conflicts = (toggle.dataset.conflicts || '').split(',').filter(Boolean);
        allToggles().forEach(function (other) {
          if (other === toggle || other.getAttribute('aria-pressed') !== 'true') return;
          var otherHandle = other.dataset.handle || '';
          var otherConflicts = (other.dataset.conflicts || '').split(',').filter(Boolean);
          if (conflicts.indexOf(otherHandle) !== -1 || otherConflicts.indexOf(handle) !== -1) setToggle(other, false);
        });
      }
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      var card = toggle.closest('.fd26-cs__product-card') || toggle;
      card.classList.toggle('is-on', on);
      var label = toggle.querySelector('[data-fd26-toggle-label]');
      if (label) label.textContent = on ? 'Added' : 'Add';
      syncQuickToggle(toggle, on);
    }

    function syncBarrierOptions() {
      if (!barrierTriggerVid || barrierTriggerVid === '0') return;
      var toggles = allToggles();
      var noFlyZone = toggles.find(function (toggle) { return toggle.dataset.vid === barrierTriggerVid; });
      var compatible = !!noFlyZone && noFlyZone.getAttribute('aria-pressed') === 'true';
      var standardBarrier = toggles.find(function (toggle) { return toggle.dataset.fd26BarrierOption === 'standard'; });
      var compatibleBarrier = toggles.find(function (toggle) { return toggle.dataset.fd26BarrierOption === 'compatible'; });
      var previous = compatible ? standardBarrier : compatibleBarrier;
      var next = compatible ? compatibleBarrier : standardBarrier;

      if (previous && previous.getAttribute('aria-pressed') === 'true') {
        setToggle(previous, false);
        if (next) setToggle(next, true);
      }
      quickToggles.forEach(function (toggle) {
        if (toggle.dataset.fd26BarrierOption) {
          toggle.hidden = toggle.dataset.fd26BarrierOption !== (compatible ? 'compatible' : 'standard');
        }
      });
    }

    function availableVariants(product) {
      return (product.variants || []).filter(function (variant) { return variant.available !== false; });
    }

    function mappedVariants(product, rule) {
      var variants = availableVariants(product);
      if (rule.netKeys && rule.netKeys.indexOf(netKey) === -1) return [];
      if (!rule.variants) return variants;
      var wantedId = parseInt(rule.variants[netKey], 10) || 0;
      if (!wantedId) return [];
      return variants.filter(function (variant) { return parseInt(variant.id, 10) === wantedId; });
    }

    function productImage(product) {
      if (product.images && product.images.length) return product.images[0].src || product.images[0];
      return product.image && (product.image.src || product.image) || '';
    }

    function variantPrice(variant) {
      if (typeof variant.price === 'number') return variant.price;
      return Math.round(parseFloat(variant.price || 0) * 100);
    }

    function appendCatalogCard(product, rule) {
      var existing = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-card]')).some(function (card) {
        return card.dataset.handle === product.handle;
      });
      if (existing) return;

      var variants = mappedVariants(product, rule);
      if (!variants.length) return;
      var firstVariant = variants[0];
      var imageUrl = productImage(product);
      var card = element('article', 'fd26-cs__product-card fd26-cs__product-card--dynamic');
      card.dataset.fd26Card = '';
      card.dataset.handle = product.handle;
      card.dataset.category = rule.category;
      card.dataset.recommended = 'false';

      var media = element('span', 'fd26-cs__product-media');
      if (imageUrl) {
        var image = element('img');
        image.src = imageUrl;
        image.alt = product.title || '';
        image.loading = 'lazy';
        media.appendChild(image);
      }
      card.appendChild(media);

      var body = element('span', 'fd26-cs__product-body');
      body.appendChild(element('span', 'fd26-cs__product-title', product.title));

      var variantLabel = element('label', 'fd26-cs__variant-field');
      if (variants.length > 1) {
        variantLabel.appendChild(element('span', '', 'Choose an option'));
        var select = element('select');
        select.dataset.fd26VariantSelect = '';
        variants.forEach(function (variant) {
          var option = element('option');
          option.value = String(variant.id);
          option.dataset.price = String(variantPrice(variant));
          option.textContent = (variant.title || 'Standard') + ' · ' + money(variantPrice(variant));
          select.appendChild(option);
        });
        variantLabel.appendChild(select);
        body.appendChild(variantLabel);
      } else if (firstVariant.title && firstVariant.title !== 'Default Title') {
        body.appendChild(element('span', 'fd26-cs__product-variant', firstVariant.title));
      }

      var footer = element('span', 'fd26-cs__product-footer');
      var price = element('strong', '', money(variantPrice(firstVariant)));
      price.dataset.fd26CardPrice = '';
      footer.appendChild(price);
      var toggle = element('button', 'fd26-cs__product-add');
      toggle.type = 'button';
      toggle.dataset.fd26Toggle = '';
      toggle.dataset.handle = product.handle;
      toggle.dataset.vid = String(firstVariant.id);
      toggle.dataset.price = String(variantPrice(firstVariant));
      toggle.dataset.title = product.title || 'Add-on';
      toggle.dataset.variantTitle = firstVariant.title === 'Default Title' ? '' : (firstVariant.title || '');
      toggle.dataset.image = imageUrl;
      toggle.dataset.conflicts = (rule.conflicts || []).join(',');
      toggle.setAttribute('aria-pressed', 'false');
      toggle.appendChild(element('span', '', 'Add'));
      toggle.firstChild.dataset.fd26ToggleLabel = '';
      footer.appendChild(toggle);
      body.appendChild(footer);
      card.appendChild(body);
      products.appendChild(card);
    }

    function applyCategory(category) {
      activeCategory = category;
      var definition = CATEGORY_DEFINITIONS[category] || CATEGORY_DEFINITIONS.recommended;
      if (categoryTitle) categoryTitle.textContent = definition.title;
      categoryButtons.forEach(function (button) {
        var current = button.dataset.fd26Category === category;
        button.classList.toggle('is-current', current);
        button.setAttribute('aria-pressed', current ? 'true' : 'false');
      });

      var visibleCount = 0;
      var noFlyZone = allToggles().find(function (toggle) { return toggle.dataset.vid === barrierTriggerVid; });
      var barrierOption = noFlyZone && noFlyZone.getAttribute('aria-pressed') === 'true' ? 'compatible' : 'standard';
      Array.prototype.slice.call(root.querySelectorAll('[data-fd26-card]')).forEach(function (card) {
        var visible = category === 'recommended'
          ? card.dataset.recommended === 'true' || card.getAttribute('aria-pressed') === 'true'
          : card.dataset.category === category;
        if (card.dataset.fd26BarrierOption) {
          visible = visible && card.dataset.fd26BarrierOption === barrierOption;
        }
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      if (catalogStatus && loadedCategories[category]) {
        catalogStatus.textContent = visibleCount ? '' : 'No mapped options are available for this net in this category.';
      }
    }

    function loadCategory(category) {
      if (loadedCategories[category]) {
        applyCategory(category);
        return Promise.resolve();
      }
      var definition = CATEGORY_DEFINITIONS[category];
      if (!definition || !definition.sources.length) return Promise.resolve();
      if (catalogStatus) catalogStatus.textContent = 'Loading compatible options…';

      return Promise.all(definition.sources.map(function (source) {
        return fetch(source, { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Catalog request failed');
          return response.json();
        });
      })).then(function (payloads) {
        payloads.forEach(function (payload) {
          (payload.products || []).forEach(function (product) {
            var rule = CATALOG_RULES[product.handle];
            if (!rule && category === 'technology') rule = { category: 'technology' };
            if (rule && rule.category === category) appendCatalogCard(product, rule);
          });
        });
        loadedCategories[category] = true;
        applyCategory(category);
      }).catch(function () {
        if (catalogStatus) catalogStatus.textContent = 'Additional options could not be loaded. Your current selections are still available.';
      });
    }

    function setCatalogExpanded(expanded) {
      if (seeAllAction) {
        seeAllAction.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        seeAllAction.textContent = expanded ? 'Recommended only' : 'See all options';
      }
      if (categories) categories.hidden = !expanded;
      if (!expanded) applyCategory('recommended');
    }

    function setNativePurchaseVisible(visible) {
      if (nativeBuyContainer) {
        nativeBuyContainer.hidden = !visible;
        nativeBuyContainer.toggleAttribute('data-fd26-native-hidden', !visible);
      }
      stickyForms.forEach(function (sticky) {
        sticky.hidden = !visible;
        sticky.toggleAttribute('data-fd26-native-hidden', !visible);
      });
    }

    function setMode(mode) {
      currentMode = mode;
      root.querySelectorAll('[data-fd26-mode-card]').forEach(function (card) {
        var input = card.querySelector('.fd26-cs__mode-input');
        card.classList.toggle('is-selected', !!input && input.checked);
      });

      var nativeMode = mode === 'net';
      setNativePurchaseVisible(nativeMode);
      if (modeActions) modeActions.hidden = mode !== 'package';
      if (packageAction) packageAction.hidden = mode !== 'package';
      if (quickPanel) quickPanel.hidden = mode !== 'custom';
      if (status) status.textContent = '';
      if (quickStatus) quickStatus.textContent = '';
      if (mode === 'custom' && !trackedQuickView) {
        trackedQuickView = true;
        track('nr_setup_quick_add_view', { path: 'quick_add' });
      }
    }

    function showStep(step) {
      var reviewing = step === 'review';
      chooseStep.hidden = reviewing;
      reviewStep.hidden = !reviewing;
      chooseProgress.classList.toggle('is-current', !reviewing);
      chooseProgress.classList.toggle('is-complete', reviewing);
      reviewProgress.classList.toggle('is-current', reviewing);
      if (reviewing) {
        reviewProgress.setAttribute('aria-current', 'step');
        chooseProgress.removeAttribute('aria-current');
      } else {
        chooseProgress.setAttribute('aria-current', 'step');
        reviewProgress.removeAttribute('aria-current');
      }
      var heading = (reviewing ? reviewStep : chooseStep).querySelector('h2');
      if (heading) {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      }
      if (dialog) dialog.scrollTop = 0;
    }

    function openDialog(path) {
      lastDialogTrigger = document.activeElement;
      setCatalogExpanded(true);
      dialog.hidden = false;
      document.body.classList.add('nr-pdp-bundle-open');
      showStep('choose');
      renderSelection();
      track('nr_setup_builder_open', { path: path || 'full_builder' });
      closeAction.focus();
    }

    function closeDialog() {
      dialog.hidden = true;
      document.body.classList.remove('nr-pdp-bundle-open');
      if (dialogStatus) dialogStatus.textContent = '';
      if (lastDialogTrigger && typeof lastDialogTrigger.focus === 'function') lastDialogTrigger.focus();
    }

    function announceCart(addJson) {
      var productForm = root.closest('product-form') || document.querySelector('product-form');
      if (productForm) {
        productForm.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: (addJson.items ? addJson.items[0] : addJson), responseJson: addJson }
        }));
      }

      fetch(cartUrl + '.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          return waitForCartDrawerReady(1400).then(function (cartDrawerReady) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            cart.sections = addJson.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: cartType === 'drawer' }
            }));

            if (cartType !== 'drawer') return;
            window.setTimeout(function () {
              var drawer = document.getElementById('mini-cart');
              if (!drawer || drawer.hasAttribute('open')) return;
              if (cartDrawerReady && typeof drawer.open !== 'undefined') drawer.open = true;
              else openMiniCartFallback(addJson.sections ? addJson.sections['mini-cart'] : '');
            }, cartDrawerReady ? 900 : 80);
          });
        });
    }

    function setBusy(button, busy) {
      if (!button) return;
      button.disabled = busy;
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    function lineItem(id, role, path) {
      return {
        id: id,
        quantity: 1,
        properties: {
          _nr_setup_instance: instanceId,
          _nr_setup_path: path,
          _nr_setup_role: role
        }
      };
    }

    function addItems(items, button, errorNode, onSuccess, meta) {
      if (!items.length || !items[0].id) return;
      meta = meta || { path: '' };
      if (errorNode) errorNode.textContent = '';
      setBusy(button, true);
      track('nr_setup_cart_attempt', {
        path: meta.path,
        cart_item_count: items.length
      });

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: 'mini-cart' })
      })
        .then(function (response) {
          return response.json().then(function (json) { return { ok: response.ok, json: json }; });
        })
        .then(function (result) {
          setBusy(button, false);
          if (!result.ok) {
            if (errorNode) errorNode.textContent = result.json && result.json.description ? result.json.description : genericError;
            track('nr_setup_cart_error', { path: meta.path, error_type: 'shopify_response' });
            return;
          }
          track('nr_setup_cart_success', { path: meta.path, cart_item_count: items.length });
          if (onSuccess) onSuccess();
          announceCart(result.json);
        })
        .catch(function () {
          setBusy(button, false);
          if (errorNode) errorNode.textContent = networkError;
          track('nr_setup_cart_error', { path: meta.path, error_type: 'network' });
        });
    }

    function addCustomSetup(path, button, errorNode, onSuccess) {
      var addOns = selectedItems();
      if (!addOns.length) {
        if (path === 'full_builder') showStep('choose');
        return;
      }
      var items = [lineItem(netVariantId, 'base', path)].concat(addOns.map(function (item) {
        return lineItem(item.id, 'add_on', path);
      }));
      addItems(items, button, errorNode, onSuccess, { path: path });
    }

    modeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        setMode(input.value);
        track('nr_setup_path_selected', {
          path: input.value === 'custom' ? 'quick_add' : (input.value === 'package' ? 'package' : 'net_only')
        });
      });
    });

    if (quickPanel) {
      quickPanel.addEventListener('click', function (event) {
        var quickToggle = event.target && event.target.closest ? event.target.closest('[data-fd26-quick-toggle]') : null;
        if (!quickToggle || !quickPanel.contains(quickToggle)) return;
        var canonical = allToggles().find(function (toggle) {
          return toggle.dataset.handle === quickToggle.dataset.handle && toggle.dataset.vid === quickToggle.dataset.vid;
        });
        if (!canonical) return;
        var on = canonical.getAttribute('aria-pressed') !== 'true';
        setToggle(canonical, on);
        renderSelection();
        track('nr_setup_add_on_toggle', {
          path: 'quick_add',
          add_on_handle: canonical.dataset.handle || '',
          add_on_variant_id: parseInt(canonical.dataset.vid, 10) || 0,
          selected: on
        });
      });
    }

    if (products) {
      products.addEventListener('click', function (event) {
        var toggle = event.target && event.target.closest ? event.target.closest('[data-fd26-toggle]') : null;
        if (!toggle || !products.contains(toggle)) return;
        var on = toggle.getAttribute('aria-pressed') !== 'true';
        setToggle(toggle, on);
        renderSelection();
        track('nr_setup_add_on_toggle', {
          path: 'full_builder',
          add_on_handle: toggle.dataset.handle || '',
          add_on_variant_id: parseInt(toggle.dataset.vid, 10) || 0,
          selected: on
        });
      });

      products.addEventListener('change', function (event) {
        var select = event.target && event.target.closest ? event.target.closest('[data-fd26-variant-select]') : null;
        if (!select) return;
        var card = select.closest('[data-fd26-card]');
        var toggle = card && card.querySelector('[data-fd26-toggle]');
        var option = select.options[select.selectedIndex];
        if (!toggle || !option) return;
        toggle.dataset.vid = option.value;
        toggle.dataset.price = option.dataset.price || '0';
        toggle.dataset.variantTitle = option.textContent.split(' · ')[0];
        var price = card.querySelector('[data-fd26-card-price]');
        if (price) price.textContent = money(parseInt(toggle.dataset.price, 10) || 0);
        if (toggle.getAttribute('aria-pressed') === 'true') renderSelection();
      });
    }

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () { loadCategory(button.dataset.fd26Category); });
    });

    if (seeAllAction) {
      seeAllAction.addEventListener('click', function () {
        var expanded = seeAllAction.getAttribute('aria-expanded') === 'true';
        setCatalogExpanded(!expanded);
      });
    }

    if (packageAction) {
      packageAction.addEventListener('click', function () {
        if (!packageVariantId) return;
        addItems([lineItem(packageVariantId, 'package', 'package')], packageAction, status, null, { path: 'package' });
      });
    }

    if (openAction) openAction.addEventListener('click', function () { openDialog('full_builder'); });
    if (closeAction) closeAction.addEventListener('click', closeDialog);
    if (backAction) backAction.addEventListener('click', function () { showStep('choose'); });
    if (reviewAction) reviewAction.addEventListener('click', function () {
      if (!selectedItems().length) return;
      track('nr_setup_review', { path: 'full_builder' });
      showStep('review');
    });
    if (quickCartAction) {
      quickCartAction.addEventListener('click', function () {
        addCustomSetup('quick_add', quickCartAction, quickStatus);
      });
    }
    if (cartAction) {
      cartAction.addEventListener('click', function () {
        addCustomSetup('full_builder', cartAction, dialogStatus, closeDialog);
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (node) { return !node.hidden && node.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('variant:changed', function (event) {
      if (!event || !event.detail || !event.detail.variant) return;
      var sourceFormId = event.target && event.target.getAttribute ? event.target.getAttribute('id') : '';
      if (productFormId && sourceFormId !== productFormId) return;
      netVariantId = parseInt(event.detail.variant.id, 10) || netVariantId;
      if (event.detail.variant.price != null) netPrice = parseInt(event.detail.variant.price, 10) || netPrice;
      root.dataset.netVariant = String(netVariantId);
      root.dataset.netPrice = String(netPrice);
      if (netPriceNode) netPriceNode.textContent = money(netPrice);
      renderSelection();
    });

    setMode(currentMode);
    renderSelection();
    applyCategory('recommended');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (trackedView || !entries.some(function (entry) { return entry.isIntersecting; })) return;
        trackedView = true;
        track('nr_setup_view', { path: 'selector' });
        observer.disconnect();
      }, { threshold: 0.35 });
      observer.observe(root);
    } else {
      trackedView = true;
      track('nr_setup_view', { path: 'selector' });
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest || !event.target.closest('#mini-cart [data-action="close"], #mini-cart .drawer__overlay')) return;
    if (window.customElements && window.customElements.get && window.customElements.get('cart-drawer')) return;
    closeMiniCartFallback();
  });

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fd26-cs]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
